import i18n from "@/i18n";
import PetrolImage from "@/assets/images/petrol.svg";
import DieselImage from "@/assets/images/diesel.svg";
import ElectricImage from "@/assets/images/electric.svg";
import HybridImage from "@/assets/images/hybrid.svg";

export default [
  {
    image: PetrolImage,
    text: i18n.t("fuel-types.petrol"),
    id: 55010
  },
  {
    image: DieselImage,
    text: i18n.t("fuel-types.diesel"),
    id: 55015
  },
  {
    image: ElectricImage,
    text: i18n.t("fuel-types.electric"),
    id: 281006
  },
  {
    image: HybridImage,
    text: i18n.t("fuel-types.hybrid"),
    id: 55020
  }
];
